import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Camera, FilePdf, ShieldCheck, ArrowSquareOut } from "@phosphor-icons/react";
import { PhotoUploadDojo } from "./PhotoUploadDojo";

const LABELS = { petits_samourais: "Petits Samouraïs (3-7 ans, parent-enfant)", jeunesse: "Jeunesse 8-12 ans (jiu-jitsu enfants)", ados: "Ados 13-17 ans (kickboxing · jiu-jitsu)" };

/** Séance photo programmes enfants : plan PDF (5 photos / programme) + suivi des consentements parents + photos déjà en Médiathèque. */
export function SeancePhoto() {
  const [etat, setEtat] = useState(null);
  const [sel, setSel] = useState(["petits_samourais", "jeunesse", "ados"]);
  const [busy, setBusy] = useState(false);
  const loadEtat = () => api.get("/contenu/seance-photo/etat").then((x) => setEtat(x.data)).catch(() => toast.error("État de la séance photo indisponible"));
  useEffect(() => { loadEtat(); }, []);
  const toggle = (k) => setSel((s) => (s.includes(k) ? s.filter((x) => x !== k) : [...s, k]));
  const pdf = async () => {
    if (!sel.length) return toast.error("Choisis au moins un programme");
    setBusy(true);
    try {
      const r = await api.get("/contenu/seance-photo.pdf", { params: { programmes: sel.join(",") }, responseType: "blob" });
      window.open(URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })), "_blank");
    } catch { toast.error("PDF impossible"); } finally { setBusy(false); }
  };
  return (
    <section className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-5 space-y-4" data-testid="seance-photo">
      <div className="flex items-start gap-3">
        <Camera size={28} className="text-amber-300 flex-shrink-0" />
        <div>
          <div className="font-bold text-zinc-100 text-lg">Séance photo — programmes enfants</div>
          <p className="text-sm text-zinc-400">5 plans par programme (sujet, cadrage, lumière) + liste de contrôle matériel et consentements. Les photos prises remplacent les images IA du moteur dès qu'elles sont téléversées dans la Médiathèque avec les consentements signés.</p>
        </div>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        {Object.entries(LABELS).map(([k, l]) => (
          <label key={k} className={`rounded-xl border p-3 text-sm cursor-pointer ${sel.includes(k) ? "border-amber-500/50 bg-amber-500/10 text-zinc-100" : "border-zinc-800 text-zinc-400"}`} data-testid={`seance-prog-${k}`}>
            <input type="checkbox" className="mr-2 accent-amber-500" checked={sel.includes(k)} onChange={() => toggle(k)} />{l}
            {etat && <div className="text-[11px] text-zinc-500 mt-1">{etat.photos_par_programme?.[k] ?? 0} photo(s) réelle(s) en Médiathèque · objectif 5</div>}
          </label>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-3 text-xs">
        <button type="button" disabled={busy} onClick={pdf} className="rounded-full bg-amber-500 text-zinc-950 font-bold px-4 py-2 inline-flex items-center gap-2 disabled:opacity-50" data-testid="seance-pdf"><FilePdf weight="bold" /> Télécharger le plan de séance (PDF)</button>
        <Link to="/app/mediatheque#consentements" className="rounded-full border border-zinc-700 text-zinc-200 px-4 py-2 inline-flex items-center gap-2" data-testid="seance-consentements"><ShieldCheck /> Envoyer les consentements aux parents <ArrowSquareOut /></Link>
        {etat && <span className="text-zinc-400" data-testid="seance-consent-stats">Consentements enfants : <b className="text-emerald-300">{etat.consentements.signes} signés</b> · <b className="text-amber-300">{etat.consentements.en_attente} en attente</b>{etat.consentements.revoques ? <> · <b className="text-red-300">{etat.consentements.revoques} révoqués</b></> : null}</span>}
      </div>
      <PhotoUploadDojo onDone={loadEtat} />
      <p className="text-[11px] text-zinc-500">Règle : seuls les enfants dont le consentement est signé entrent dans le cadre. Envoie les liens 48 h avant la séance ; les parents signent en ligne depuis leur téléphone.</p>
    </section>
  );
}
